import { format } from 'date-fns'

import { isBRDate, isUSDate, getDateObject } from './date'

function getValue(item) {
    return item?.value || item
}

export default {
    extractFormValues: (data, handleDates = true, handleArrays = true, handleFiles = true) => {
        const temp = Object.entries(data).reduce((result, [key, value]) => {
            if (value?.value !== undefined) { // Extrai a propriedade value dos campos do tipo select (Formik) e insere na raiz do objeto
                value = value.value
            }

            if (handleDates) {
                if (isBRDate(value)) {
                    value = format(getDateObject(value), 'yyyy-MM-dd HH:mm:ss')
                } else if (isUSDate(value)) {
                    value = value.substr(0, 10)
                } else if (value instanceof Date) {
                    value = format(value, 'yyyy-MM-dd HH:mm:ss')
                }
            }

            if (handleArrays) { // Extrai a propriedade value dos campos preenchidos com FieldArray
                for (const key of Object.keys(data)) {
                    if (Array.isArray(data[key]) && data[key].every(item => !(item instanceof File))) {
                        for (let item of data[key]) {
                            for (let k of Object.keys(item)) {
                                item[k] = getValue(item[k]?.value || item[k])
                            }
                        }
                    }
                }
            }

            return {
                ...result,
                [key]: value === undefined ? '' : value
            }
        }, {})

        if (handleFiles) {
            const formData = new FormData()

            const fileFieldsKeys = []

            for (const [key, val] of Object.entries(data)) {
                if (val instanceof File) {
                    val = [val]

                    fileFieldsKeys.push(key)
                }

                if (Array.isArray(val) && val.some(item => item instanceof File)) {
                    const files = val.filter(item => item instanceof File)
                    
                    files.forEach(arquivo => {
                        const blob = new Blob([arquivo], { type: arquivo.type })

                        const extension = arquivo.name.split('.').at(-1)

                        formData.append(key, blob, arquivo.name || `arquivo.${extension}`)

                        fileFieldsKeys.push(key)
                    })
                }

                if(Array.isArray(val) && val.some(item => item.id && item.link)) {
                    const uploadedFiles = val.filter(item => item.id && item.link)

                    uploadedFiles.forEach(arquivo => {
                        formData.append(`old_${key}`, arquivo.id)

                        fileFieldsKeys.push(`old_${key}`)
                    })
                }
            }

            if(fileFieldsKeys.length) {
                for (const [k, v] of Object.entries(temp)) {
                    if(fileFieldsKeys.includes(k)) {
                        continue
                    }

                    formData.append(k, v)
                }

                return formData
            }
        }

        return temp
    }
}
